export default class TableNotes {
  constructor() {
    this.styles = {
      textLeft: { "text-align": "left" },
      textRight: { "text-align": "right" },
      textCenter: { "text-align": "center" },
      width10: { width: "5px !important" },
      textElipsis: {
        "max-width": "5vw !important",
        "word-break": "keep-all !important",
        "white-space": "nowrap !important",
        overflow: "hidden !important",
        "text-overflow": "ellipsis !important",
      },
    };
    this.defaultStyles = {
      padding: "5px",
      "border-style": "none !important",
      "vertical-align": "middle !important",
    };
  }

  spedNotes(notes) {
    const defaultStyles = this.defaultStyles;
    const styles = this.styles;

    const tHeaders = [
      {
        title: "CPF/CNPJ",
        name: "cpfCnpj",
        type: "string",
        style: { ...defaultStyles },
      },
      {
        title: "Nome",
        name: "xNome",
        type: "string",
        style: { ...defaultStyles },
      },
      {
        title: "Nº NF",
        name: "nNf",
        type: "number",
        style: { ...defaultStyles },
      },
      {
        title: "Emissão",
        name: "dEmi",
        type: "string",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "Chave",
        name: "chvNfe",
        type: "string",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "VL. Merc.",
        name: "vNf",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "VL. Doc.",
        name: "vlDoc",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "VL. ICMS",
        name: "vlIcms",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "VL. ST",
        name: "vlSt",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "Vl. Difal Apurado",
        name: "vDifalApurado",
        type: "number",
        style: { ...defaultStyles, ...styles.textRight },
      },
      {
        title: "Boleto Guia ST",
        name: "guiaSt",
        type: "default",
        style: { ...defaultStyles, ...styles.textCenter },
      },
      {
        title: "Danfe",
        name: "danfe",
        type: "default",
        style: { ...defaultStyles, ...styles.textCenter },
      },
    ];

    const tBody = notes.map((item, index) => {
      return {
        line: index,
        idNfe: item.idNfe,
        cpfCnpj: item.cpfCnpj,
        chvNfe: item.chvNfe,
        nNf: item.nNf,
        aliqOrigem: item.aliqOrigem,
        pOutro: item.pOutro,
        isCalculating: false,
        idEmpresa: item.idEmpresa,
        vlIcms: item.vlIcms,
        vlSt: item.vlSt,
        aliqDestino: item.aliqDestino,
        aliqDifal: item.aliqDifal,
        vNf: item.vNf,
        ser: item.ser,
        codMod: item.codMod,
        expanded: false,
        cells: [
          {
            value: item.cpfCnpj,
            filter: "cpfCnpj",
            style: { ...defaultStyles, ...styles.textLeft },
          },
          {
            value: item.xNome,
            name: "xNome",
            style: { ...defaultStyles, ...styles.textElipsis },
          },
          {
            value: item.nNf,
            name: "nNf",
            style: { ...defaultStyles, ...styles.textLeft },
          },
          {
            value: item.dEmi,
            name: "dEmi",
            filter: "date",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          {
            value: item.chvNfe,
            name: "chvNfe",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          {
            value: item.vProd,
            name: "vProd",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vNf,
            name: "vNf",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vlIcms,
            name: "vlIcms",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vlSt,
            name: "vlSt",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: item.vlIcmsDar,
            name: "vDifalApurado",
            filter: "currency",
            style: { ...defaultStyles, ...styles.textRight },
          },
          {
            value: "guiaSt",
            style: { ...defaultStyles, ...styles.textCenter },
          },
          { value: "danfe", style: { ...defaultStyles, ...styles.textCenter } },
        ],
      };
    });

    return {
      tHeaders,
      tBody,
    };
  }
}
